import { render, staticRenderFns } from "./Azioni.vue?vue&type=template&id=b2c28cde&scoped=true&lang=pug&"
import script from "./Azioni.vue?vue&type=script&lang=ts&"
export * from "./Azioni.vue?vue&type=script&lang=ts&"
import style0 from "./Azioni.vue?vue&type=style&index=0&id=b2c28cde&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c28cde",
  null
  
)

export default component.exports